import { applyAction } from "./appliers";
import type { RunHorsesAction, RunHorsesState } from "./types";
import { validateAction } from "./validators";

export interface ReduceResult {
  readonly state: RunHorsesState;
  readonly accepted: boolean;
  readonly error?: string;
}

export function reduceGameState(
  state: RunHorsesState,
  action: RunHorsesAction,
): RunHorsesState {
  return applyAction(state, action);
}

export function validateAndReduceGameState(
  state: RunHorsesState,
  action: RunHorsesAction,
): ReduceResult {
  const validation = validateAction(state, action);
  if (!validation.valid) {
    return { state, accepted: false, error: validation.error };
  }
  return { state: reduceGameState(state, action), accepted: true };
}
